// Ce fichier est généré automatiquement par utils/spritesheet-config-generator
// Ne pas modifier manuellement
// Dossier: kitsune | Taille: 256x256px

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const KitsuneSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'kitsune-appear',
    metadata: {
      frames: {
        'kitsune-appear-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-appear-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/appear.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-appear-bottom': [
          'kitsune-appear-bottom-0',
          'kitsune-appear-bottom-1',
          'kitsune-appear-bottom-2',
          'kitsune-appear-bottom-3',
          'kitsune-appear-bottom-4',
          'kitsune-appear-bottom-5',
          'kitsune-appear-bottom-6',
          'kitsune-appear-bottom-7',
          'kitsune-appear-bottom-8',
          'kitsune-appear-bottom-9',
          'kitsune-appear-bottom-10',
          'kitsune-appear-bottom-11',
          'kitsune-appear-bottom-12',
          'kitsune-appear-bottom-13',
          'kitsune-appear-bottom-14',
          'kitsune-appear-bottom-15',
        ],
        'kitsune-appear-bottom-left': [
          'kitsune-appear-bottom-left-0',
          'kitsune-appear-bottom-left-1',
          'kitsune-appear-bottom-left-2',
          'kitsune-appear-bottom-left-3',
          'kitsune-appear-bottom-left-4',
          'kitsune-appear-bottom-left-5',
          'kitsune-appear-bottom-left-6',
          'kitsune-appear-bottom-left-7',
          'kitsune-appear-bottom-left-8',
          'kitsune-appear-bottom-left-9',
          'kitsune-appear-bottom-left-10',
          'kitsune-appear-bottom-left-11',
          'kitsune-appear-bottom-left-12',
          'kitsune-appear-bottom-left-13',
          'kitsune-appear-bottom-left-14',
          'kitsune-appear-bottom-left-15',
        ],
        'kitsune-appear-left': [
          'kitsune-appear-left-0',
          'kitsune-appear-left-1',
          'kitsune-appear-left-2',
          'kitsune-appear-left-3',
          'kitsune-appear-left-4',
          'kitsune-appear-left-5',
          'kitsune-appear-left-6',
          'kitsune-appear-left-7',
          'kitsune-appear-left-8',
          'kitsune-appear-left-9',
          'kitsune-appear-left-10',
          'kitsune-appear-left-11',
          'kitsune-appear-left-12',
          'kitsune-appear-left-13',
          'kitsune-appear-left-14',
          'kitsune-appear-left-15',
        ],
        'kitsune-appear-top-left': [
          'kitsune-appear-top-left-0',
          'kitsune-appear-top-left-1',
          'kitsune-appear-top-left-2',
          'kitsune-appear-top-left-3',
          'kitsune-appear-top-left-4',
          'kitsune-appear-top-left-5',
          'kitsune-appear-top-left-6',
          'kitsune-appear-top-left-7',
          'kitsune-appear-top-left-8',
          'kitsune-appear-top-left-9',
          'kitsune-appear-top-left-10',
          'kitsune-appear-top-left-11',
          'kitsune-appear-top-left-12',
          'kitsune-appear-top-left-13',
          'kitsune-appear-top-left-14',
          'kitsune-appear-top-left-15',
        ],
        'kitsune-appear-top': [
          'kitsune-appear-top-0',
          'kitsune-appear-top-1',
          'kitsune-appear-top-2',
          'kitsune-appear-top-3',
          'kitsune-appear-top-4',
          'kitsune-appear-top-5',
          'kitsune-appear-top-6',
          'kitsune-appear-top-7',
          'kitsune-appear-top-8',
          'kitsune-appear-top-9',
          'kitsune-appear-top-10',
          'kitsune-appear-top-11',
          'kitsune-appear-top-12',
          'kitsune-appear-top-13',
          'kitsune-appear-top-14',
          'kitsune-appear-top-15',
        ],
      },
    },
  },
  {
    name: 'kitsune-attack',
    metadata: {
      frames: {
        'kitsune-attack-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-attack-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/attack.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-attack-bottom': [
          'kitsune-attack-bottom-0',
          'kitsune-attack-bottom-1',
          'kitsune-attack-bottom-2',
          'kitsune-attack-bottom-3',
          'kitsune-attack-bottom-4',
          'kitsune-attack-bottom-5',
          'kitsune-attack-bottom-6',
          'kitsune-attack-bottom-7',
          'kitsune-attack-bottom-8',
          'kitsune-attack-bottom-9',
          'kitsune-attack-bottom-10',
          'kitsune-attack-bottom-11',
          'kitsune-attack-bottom-12',
          'kitsune-attack-bottom-13',
          'kitsune-attack-bottom-14',
          'kitsune-attack-bottom-15',
        ],
        'kitsune-attack-bottom-left': [
          'kitsune-attack-bottom-left-0',
          'kitsune-attack-bottom-left-1',
          'kitsune-attack-bottom-left-2',
          'kitsune-attack-bottom-left-3',
          'kitsune-attack-bottom-left-4',
          'kitsune-attack-bottom-left-5',
          'kitsune-attack-bottom-left-6',
          'kitsune-attack-bottom-left-7',
          'kitsune-attack-bottom-left-8',
          'kitsune-attack-bottom-left-9',
          'kitsune-attack-bottom-left-10',
          'kitsune-attack-bottom-left-11',
          'kitsune-attack-bottom-left-12',
          'kitsune-attack-bottom-left-13',
          'kitsune-attack-bottom-left-14',
          'kitsune-attack-bottom-left-15',
        ],
        'kitsune-attack-left': [
          'kitsune-attack-left-0',
          'kitsune-attack-left-1',
          'kitsune-attack-left-2',
          'kitsune-attack-left-3',
          'kitsune-attack-left-4',
          'kitsune-attack-left-5',
          'kitsune-attack-left-6',
          'kitsune-attack-left-7',
          'kitsune-attack-left-8',
          'kitsune-attack-left-9',
          'kitsune-attack-left-10',
          'kitsune-attack-left-11',
          'kitsune-attack-left-12',
          'kitsune-attack-left-13',
          'kitsune-attack-left-14',
          'kitsune-attack-left-15',
        ],
        'kitsune-attack-top-left': [
          'kitsune-attack-top-left-0',
          'kitsune-attack-top-left-1',
          'kitsune-attack-top-left-2',
          'kitsune-attack-top-left-3',
          'kitsune-attack-top-left-4',
          'kitsune-attack-top-left-5',
          'kitsune-attack-top-left-6',
          'kitsune-attack-top-left-7',
          'kitsune-attack-top-left-8',
          'kitsune-attack-top-left-9',
          'kitsune-attack-top-left-10',
          'kitsune-attack-top-left-11',
          'kitsune-attack-top-left-12',
          'kitsune-attack-top-left-13',
          'kitsune-attack-top-left-14',
          'kitsune-attack-top-left-15',
        ],
        'kitsune-attack-top': [
          'kitsune-attack-top-0',
          'kitsune-attack-top-1',
          'kitsune-attack-top-2',
          'kitsune-attack-top-3',
          'kitsune-attack-top-4',
          'kitsune-attack-top-5',
          'kitsune-attack-top-6',
          'kitsune-attack-top-7',
          'kitsune-attack-top-8',
          'kitsune-attack-top-9',
          'kitsune-attack-top-10',
          'kitsune-attack-top-11',
          'kitsune-attack-top-12',
          'kitsune-attack-top-13',
          'kitsune-attack-top-14',
          'kitsune-attack-top-15',
        ],
      },
    },
  },
  {
    name: 'kitsune-death',
    metadata: {
      frames: {
        'kitsune-death-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-death-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/death.png',
        size: {
          w: 5120,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-death-bottom': [
          'kitsune-death-bottom-0',
          'kitsune-death-bottom-1',
          'kitsune-death-bottom-2',
          'kitsune-death-bottom-3',
          'kitsune-death-bottom-4',
          'kitsune-death-bottom-5',
          'kitsune-death-bottom-6',
          'kitsune-death-bottom-7',
          'kitsune-death-bottom-8',
          'kitsune-death-bottom-9',
          'kitsune-death-bottom-10',
          'kitsune-death-bottom-11',
          'kitsune-death-bottom-12',
          'kitsune-death-bottom-13',
          'kitsune-death-bottom-14',
          'kitsune-death-bottom-15',
          'kitsune-death-bottom-16',
          'kitsune-death-bottom-17',
          'kitsune-death-bottom-18',
          'kitsune-death-bottom-19',
        ],
        'kitsune-death-bottom-left': [
          'kitsune-death-bottom-left-0',
          'kitsune-death-bottom-left-1',
          'kitsune-death-bottom-left-2',
          'kitsune-death-bottom-left-3',
          'kitsune-death-bottom-left-4',
          'kitsune-death-bottom-left-5',
          'kitsune-death-bottom-left-6',
          'kitsune-death-bottom-left-7',
          'kitsune-death-bottom-left-8',
          'kitsune-death-bottom-left-9',
          'kitsune-death-bottom-left-10',
          'kitsune-death-bottom-left-11',
          'kitsune-death-bottom-left-12',
          'kitsune-death-bottom-left-13',
          'kitsune-death-bottom-left-14',
          'kitsune-death-bottom-left-15',
          'kitsune-death-bottom-left-16',
          'kitsune-death-bottom-left-17',
          'kitsune-death-bottom-left-18',
          'kitsune-death-bottom-left-19',
        ],
        'kitsune-death-left': [
          'kitsune-death-left-0',
          'kitsune-death-left-1',
          'kitsune-death-left-2',
          'kitsune-death-left-3',
          'kitsune-death-left-4',
          'kitsune-death-left-5',
          'kitsune-death-left-6',
          'kitsune-death-left-7',
          'kitsune-death-left-8',
          'kitsune-death-left-9',
          'kitsune-death-left-10',
          'kitsune-death-left-11',
          'kitsune-death-left-12',
          'kitsune-death-left-13',
          'kitsune-death-left-14',
          'kitsune-death-left-15',
          'kitsune-death-left-16',
          'kitsune-death-left-17',
          'kitsune-death-left-18',
          'kitsune-death-left-19',
        ],
        'kitsune-death-top-left': [
          'kitsune-death-top-left-0',
          'kitsune-death-top-left-1',
          'kitsune-death-top-left-2',
          'kitsune-death-top-left-3',
          'kitsune-death-top-left-4',
          'kitsune-death-top-left-5',
          'kitsune-death-top-left-6',
          'kitsune-death-top-left-7',
          'kitsune-death-top-left-8',
          'kitsune-death-top-left-9',
          'kitsune-death-top-left-10',
          'kitsune-death-top-left-11',
          'kitsune-death-top-left-12',
          'kitsune-death-top-left-13',
          'kitsune-death-top-left-14',
          'kitsune-death-top-left-15',
          'kitsune-death-top-left-16',
          'kitsune-death-top-left-17',
          'kitsune-death-top-left-18',
          'kitsune-death-top-left-19',
        ],
        'kitsune-death-top': [
          'kitsune-death-top-0',
          'kitsune-death-top-1',
          'kitsune-death-top-2',
          'kitsune-death-top-3',
          'kitsune-death-top-4',
          'kitsune-death-top-5',
          'kitsune-death-top-6',
          'kitsune-death-top-7',
          'kitsune-death-top-8',
          'kitsune-death-top-9',
          'kitsune-death-top-10',
          'kitsune-death-top-11',
          'kitsune-death-top-12',
          'kitsune-death-top-13',
          'kitsune-death-top-14',
          'kitsune-death-top-15',
          'kitsune-death-top-16',
          'kitsune-death-top-17',
          'kitsune-death-top-18',
          'kitsune-death-top-19',
        ],
      },
    },
  },
  {
    name: 'kitsune-disappear',
    metadata: {
      frames: {
        'kitsune-disappear-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-disappear-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/disappear.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-disappear-bottom': [
          'kitsune-disappear-bottom-0',
          'kitsune-disappear-bottom-1',
          'kitsune-disappear-bottom-2',
          'kitsune-disappear-bottom-3',
          'kitsune-disappear-bottom-4',
          'kitsune-disappear-bottom-5',
          'kitsune-disappear-bottom-6',
          'kitsune-disappear-bottom-7',
          'kitsune-disappear-bottom-8',
          'kitsune-disappear-bottom-9',
          'kitsune-disappear-bottom-10',
          'kitsune-disappear-bottom-11',
          'kitsune-disappear-bottom-12',
          'kitsune-disappear-bottom-13',
          'kitsune-disappear-bottom-14',
          'kitsune-disappear-bottom-15',
        ],
        'kitsune-disappear-bottom-left': [
          'kitsune-disappear-bottom-left-0',
          'kitsune-disappear-bottom-left-1',
          'kitsune-disappear-bottom-left-2',
          'kitsune-disappear-bottom-left-3',
          'kitsune-disappear-bottom-left-4',
          'kitsune-disappear-bottom-left-5',
          'kitsune-disappear-bottom-left-6',
          'kitsune-disappear-bottom-left-7',
          'kitsune-disappear-bottom-left-8',
          'kitsune-disappear-bottom-left-9',
          'kitsune-disappear-bottom-left-10',
          'kitsune-disappear-bottom-left-11',
          'kitsune-disappear-bottom-left-12',
          'kitsune-disappear-bottom-left-13',
          'kitsune-disappear-bottom-left-14',
          'kitsune-disappear-bottom-left-15',
        ],
        'kitsune-disappear-left': [
          'kitsune-disappear-left-0',
          'kitsune-disappear-left-1',
          'kitsune-disappear-left-2',
          'kitsune-disappear-left-3',
          'kitsune-disappear-left-4',
          'kitsune-disappear-left-5',
          'kitsune-disappear-left-6',
          'kitsune-disappear-left-7',
          'kitsune-disappear-left-8',
          'kitsune-disappear-left-9',
          'kitsune-disappear-left-10',
          'kitsune-disappear-left-11',
          'kitsune-disappear-left-12',
          'kitsune-disappear-left-13',
          'kitsune-disappear-left-14',
          'kitsune-disappear-left-15',
        ],
        'kitsune-disappear-top-left': [
          'kitsune-disappear-top-left-0',
          'kitsune-disappear-top-left-1',
          'kitsune-disappear-top-left-2',
          'kitsune-disappear-top-left-3',
          'kitsune-disappear-top-left-4',
          'kitsune-disappear-top-left-5',
          'kitsune-disappear-top-left-6',
          'kitsune-disappear-top-left-7',
          'kitsune-disappear-top-left-8',
          'kitsune-disappear-top-left-9',
          'kitsune-disappear-top-left-10',
          'kitsune-disappear-top-left-11',
          'kitsune-disappear-top-left-12',
          'kitsune-disappear-top-left-13',
          'kitsune-disappear-top-left-14',
          'kitsune-disappear-top-left-15',
        ],
        'kitsune-disappear-top': [
          'kitsune-disappear-top-0',
          'kitsune-disappear-top-1',
          'kitsune-disappear-top-2',
          'kitsune-disappear-top-3',
          'kitsune-disappear-top-4',
          'kitsune-disappear-top-5',
          'kitsune-disappear-top-6',
          'kitsune-disappear-top-7',
          'kitsune-disappear-top-8',
          'kitsune-disappear-top-9',
          'kitsune-disappear-top-10',
          'kitsune-disappear-top-11',
          'kitsune-disappear-top-12',
          'kitsune-disappear-top-13',
          'kitsune-disappear-top-14',
          'kitsune-disappear-top-15',
        ],
      },
    },
  },
  {
    name: 'kitsune-hit',
    metadata: {
      frames: {
        'kitsune-hit-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-hit-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/hit.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-hit-bottom': [
          'kitsune-hit-bottom-0',
          'kitsune-hit-bottom-1',
          'kitsune-hit-bottom-2',
          'kitsune-hit-bottom-3',
          'kitsune-hit-bottom-4',
          'kitsune-hit-bottom-5',
          'kitsune-hit-bottom-6',
          'kitsune-hit-bottom-7',
          'kitsune-hit-bottom-8',
          'kitsune-hit-bottom-9',
          'kitsune-hit-bottom-10',
          'kitsune-hit-bottom-11',
          'kitsune-hit-bottom-12',
          'kitsune-hit-bottom-13',
          'kitsune-hit-bottom-14',
          'kitsune-hit-bottom-15',
        ],
        'kitsune-hit-bottom-left': [
          'kitsune-hit-bottom-left-0',
          'kitsune-hit-bottom-left-1',
          'kitsune-hit-bottom-left-2',
          'kitsune-hit-bottom-left-3',
          'kitsune-hit-bottom-left-4',
          'kitsune-hit-bottom-left-5',
          'kitsune-hit-bottom-left-6',
          'kitsune-hit-bottom-left-7',
          'kitsune-hit-bottom-left-8',
          'kitsune-hit-bottom-left-9',
          'kitsune-hit-bottom-left-10',
          'kitsune-hit-bottom-left-11',
          'kitsune-hit-bottom-left-12',
          'kitsune-hit-bottom-left-13',
          'kitsune-hit-bottom-left-14',
          'kitsune-hit-bottom-left-15',
        ],
        'kitsune-hit-left': [
          'kitsune-hit-left-0',
          'kitsune-hit-left-1',
          'kitsune-hit-left-2',
          'kitsune-hit-left-3',
          'kitsune-hit-left-4',
          'kitsune-hit-left-5',
          'kitsune-hit-left-6',
          'kitsune-hit-left-7',
          'kitsune-hit-left-8',
          'kitsune-hit-left-9',
          'kitsune-hit-left-10',
          'kitsune-hit-left-11',
          'kitsune-hit-left-12',
          'kitsune-hit-left-13',
          'kitsune-hit-left-14',
          'kitsune-hit-left-15',
        ],
        'kitsune-hit-top-left': [
          'kitsune-hit-top-left-0',
          'kitsune-hit-top-left-1',
          'kitsune-hit-top-left-2',
          'kitsune-hit-top-left-3',
          'kitsune-hit-top-left-4',
          'kitsune-hit-top-left-5',
          'kitsune-hit-top-left-6',
          'kitsune-hit-top-left-7',
          'kitsune-hit-top-left-8',
          'kitsune-hit-top-left-9',
          'kitsune-hit-top-left-10',
          'kitsune-hit-top-left-11',
          'kitsune-hit-top-left-12',
          'kitsune-hit-top-left-13',
          'kitsune-hit-top-left-14',
          'kitsune-hit-top-left-15',
        ],
        'kitsune-hit-top': [
          'kitsune-hit-top-0',
          'kitsune-hit-top-1',
          'kitsune-hit-top-2',
          'kitsune-hit-top-3',
          'kitsune-hit-top-4',
          'kitsune-hit-top-5',
          'kitsune-hit-top-6',
          'kitsune-hit-top-7',
          'kitsune-hit-top-8',
          'kitsune-hit-top-9',
          'kitsune-hit-top-10',
          'kitsune-hit-top-11',
          'kitsune-hit-top-12',
          'kitsune-hit-top-13',
          'kitsune-hit-top-14',
          'kitsune-hit-top-15',
        ],
      },
    },
  },
  {
    name: 'kitsune-idle',
    metadata: {
      frames: {
        'kitsune-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-idle-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/idle.png',
        size: {
          w: 5120,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-idle-bottom': [
          'kitsune-idle-bottom-0',
          'kitsune-idle-bottom-1',
          'kitsune-idle-bottom-2',
          'kitsune-idle-bottom-3',
          'kitsune-idle-bottom-4',
          'kitsune-idle-bottom-5',
          'kitsune-idle-bottom-6',
          'kitsune-idle-bottom-7',
          'kitsune-idle-bottom-8',
          'kitsune-idle-bottom-9',
          'kitsune-idle-bottom-10',
          'kitsune-idle-bottom-11',
          'kitsune-idle-bottom-12',
          'kitsune-idle-bottom-13',
          'kitsune-idle-bottom-14',
          'kitsune-idle-bottom-15',
          'kitsune-idle-bottom-16',
          'kitsune-idle-bottom-17',
          'kitsune-idle-bottom-18',
          'kitsune-idle-bottom-19',
        ],
        'kitsune-idle-bottom-left': [
          'kitsune-idle-bottom-left-0',
          'kitsune-idle-bottom-left-1',
          'kitsune-idle-bottom-left-2',
          'kitsune-idle-bottom-left-3',
          'kitsune-idle-bottom-left-4',
          'kitsune-idle-bottom-left-5',
          'kitsune-idle-bottom-left-6',
          'kitsune-idle-bottom-left-7',
          'kitsune-idle-bottom-left-8',
          'kitsune-idle-bottom-left-9',
          'kitsune-idle-bottom-left-10',
          'kitsune-idle-bottom-left-11',
          'kitsune-idle-bottom-left-12',
          'kitsune-idle-bottom-left-13',
          'kitsune-idle-bottom-left-14',
          'kitsune-idle-bottom-left-15',
          'kitsune-idle-bottom-left-16',
          'kitsune-idle-bottom-left-17',
          'kitsune-idle-bottom-left-18',
          'kitsune-idle-bottom-left-19',
        ],
        'kitsune-idle-left': [
          'kitsune-idle-left-0',
          'kitsune-idle-left-1',
          'kitsune-idle-left-2',
          'kitsune-idle-left-3',
          'kitsune-idle-left-4',
          'kitsune-idle-left-5',
          'kitsune-idle-left-6',
          'kitsune-idle-left-7',
          'kitsune-idle-left-8',
          'kitsune-idle-left-9',
          'kitsune-idle-left-10',
          'kitsune-idle-left-11',
          'kitsune-idle-left-12',
          'kitsune-idle-left-13',
          'kitsune-idle-left-14',
          'kitsune-idle-left-15',
          'kitsune-idle-left-16',
          'kitsune-idle-left-17',
          'kitsune-idle-left-18',
          'kitsune-idle-left-19',
        ],
        'kitsune-idle-top-left': [
          'kitsune-idle-top-left-0',
          'kitsune-idle-top-left-1',
          'kitsune-idle-top-left-2',
          'kitsune-idle-top-left-3',
          'kitsune-idle-top-left-4',
          'kitsune-idle-top-left-5',
          'kitsune-idle-top-left-6',
          'kitsune-idle-top-left-7',
          'kitsune-idle-top-left-8',
          'kitsune-idle-top-left-9',
          'kitsune-idle-top-left-10',
          'kitsune-idle-top-left-11',
          'kitsune-idle-top-left-12',
          'kitsune-idle-top-left-13',
          'kitsune-idle-top-left-14',
          'kitsune-idle-top-left-15',
          'kitsune-idle-top-left-16',
          'kitsune-idle-top-left-17',
          'kitsune-idle-top-left-18',
          'kitsune-idle-top-left-19',
        ],
        'kitsune-idle-top': [
          'kitsune-idle-top-0',
          'kitsune-idle-top-1',
          'kitsune-idle-top-2',
          'kitsune-idle-top-3',
          'kitsune-idle-top-4',
          'kitsune-idle-top-5',
          'kitsune-idle-top-6',
          'kitsune-idle-top-7',
          'kitsune-idle-top-8',
          'kitsune-idle-top-9',
          'kitsune-idle-top-10',
          'kitsune-idle-top-11',
          'kitsune-idle-top-12',
          'kitsune-idle-top-13',
          'kitsune-idle-top-14',
          'kitsune-idle-top-15',
          'kitsune-idle-top-16',
          'kitsune-idle-top-17',
          'kitsune-idle-top-18',
          'kitsune-idle-top-19',
        ],
      },
    },
  },
  {
    name: 'kitsune-run',
    metadata: {
      frames: {
        'kitsune-run-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'kitsune-run-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/kitsune/run.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'kitsune-run-bottom': [
          'kitsune-run-bottom-0',
          'kitsune-run-bottom-1',
          'kitsune-run-bottom-2',
          'kitsune-run-bottom-3',
          'kitsune-run-bottom-4',
          'kitsune-run-bottom-5',
          'kitsune-run-bottom-6',
          'kitsune-run-bottom-7',
          'kitsune-run-bottom-8',
          'kitsune-run-bottom-9',
          'kitsune-run-bottom-10',
          'kitsune-run-bottom-11',
          'kitsune-run-bottom-12',
          'kitsune-run-bottom-13',
          'kitsune-run-bottom-14',
          'kitsune-run-bottom-15',
        ],
        'kitsune-run-bottom-left': [
          'kitsune-run-bottom-left-0',
          'kitsune-run-bottom-left-1',
          'kitsune-run-bottom-left-2',
          'kitsune-run-bottom-left-3',
          'kitsune-run-bottom-left-4',
          'kitsune-run-bottom-left-5',
          'kitsune-run-bottom-left-6',
          'kitsune-run-bottom-left-7',
          'kitsune-run-bottom-left-8',
          'kitsune-run-bottom-left-9',
          'kitsune-run-bottom-left-10',
          'kitsune-run-bottom-left-11',
          'kitsune-run-bottom-left-12',
          'kitsune-run-bottom-left-13',
          'kitsune-run-bottom-left-14',
          'kitsune-run-bottom-left-15',
        ],
        'kitsune-run-left': [
          'kitsune-run-left-0',
          'kitsune-run-left-1',
          'kitsune-run-left-2',
          'kitsune-run-left-3',
          'kitsune-run-left-4',
          'kitsune-run-left-5',
          'kitsune-run-left-6',
          'kitsune-run-left-7',
          'kitsune-run-left-8',
          'kitsune-run-left-9',
          'kitsune-run-left-10',
          'kitsune-run-left-11',
          'kitsune-run-left-12',
          'kitsune-run-left-13',
          'kitsune-run-left-14',
          'kitsune-run-left-15',
        ],
        'kitsune-run-top-left': [
          'kitsune-run-top-left-0',
          'kitsune-run-top-left-1',
          'kitsune-run-top-left-2',
          'kitsune-run-top-left-3',
          'kitsune-run-top-left-4',
          'kitsune-run-top-left-5',
          'kitsune-run-top-left-6',
          'kitsune-run-top-left-7',
          'kitsune-run-top-left-8',
          'kitsune-run-top-left-9',
          'kitsune-run-top-left-10',
          'kitsune-run-top-left-11',
          'kitsune-run-top-left-12',
          'kitsune-run-top-left-13',
          'kitsune-run-top-left-14',
          'kitsune-run-top-left-15',
        ],
        'kitsune-run-top': [
          'kitsune-run-top-0',
          'kitsune-run-top-1',
          'kitsune-run-top-2',
          'kitsune-run-top-3',
          'kitsune-run-top-4',
          'kitsune-run-top-5',
          'kitsune-run-top-6',
          'kitsune-run-top-7',
          'kitsune-run-top-8',
          'kitsune-run-top-9',
          'kitsune-run-top-10',
          'kitsune-run-top-11',
          'kitsune-run-top-12',
          'kitsune-run-top-13',
          'kitsune-run-top-14',
          'kitsune-run-top-15',
        ],
      },
    },
  },
];
